<template>
  <transition>
    <div class="switch_button">
        <div class="switch_button-title">
          {{  title  }}
        </div>
        <label 
          class="switch_button-checkbox"
          @click="change"
        >
          <span
            :class="{ 'checked': switched }"
            :checked="false"
          />
          <span class="slider round"></span>
        </label>
    </div>
  </transition>  
</template>
<script>
export default {
  name:'SwitchButton',
  props: {
    title: {
      type: String,
      required: true
    },
    switched: {
      type: Boolean,
      default: false
    }
  },
  
  methods: {
    change() {
      this.$emit('change')
    }
  }
}
</script>
<style lang="scss" scoped>
 .switch_button {
    display: flex;


    &-title {
      margin-right: 10px;
      font-weight: 400;
    }

    &-checkbox {
      position: relative;
      display: inline-block;
      width: 50px;
      height: 26px;

      input { 
        opacity: 0;
        width: 0;
        height: 0;
      }

      .slider {
        position: absolute;
        cursor: pointer;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        background-color: #ccc;
        -webkit-transition: .4s;
        transition: .4s;

        &:before {
          position: absolute;
          content: "";
          height: 22px;
          width: 22px;
          left: 2px;
          bottom: 2px;
          background-color: white;
          -webkit-transition: .4s;
          transition: .4s;
        }
      }

      .checked + .slider {
        background-color: #2196F3;
      }

      .checked + .slider:before {
        -webkit-transform: translateX(24px);
        -ms-transform: translateX(24px);
        transform: translateX(24px);
      }

      .slider.round {
        border-radius: 34px;
      }

      .slider.round:before {
        border-radius: 50%;
      }
    }
  }
</style>